<template>
  <div v-if="loading" class="flex h-full justify-center items-center">
    <loading-spinner diameter="64px" />
  </div>

  <alert-badge
    v-else-if="error.title"
    isDanger
    :title="error.title"
    :body="error.body"
    @dismissed="
      () => {
        error.title = ''
        error.body = ''
      }
    "
  />

  <tag-form
    v-else
    :initTag="initTag"
    :successMsg="$t('actions.saveChangesSuccess')"
    :submitAction="update"
  />
</template>

<script lang="ts">
import { defineComponent, onBeforeMount, ref } from 'vue'

import { useHTTP } from '@/plugins/http'

import Tag from '@/models/inventory/Tag'

// components
import AlertBadge from '@/components/AlertBadge.vue'
import LoadingSpinner from '@/components/LoadingSpinner.vue'
import TagForm from '@/views/inventory/tags/TagForm.vue'
import { useRoute } from 'vue-router'

export default defineComponent({
  name: 'tag',
  components: {
    AlertBadge,
    LoadingSpinner,
    TagForm
  },
  setup() {
    const initTag = ref(new Tag())
    const http = useHTTP()
    const loading = ref(true)
    const error = ref({ title: '', body: '' })
    const route = useRoute()

    onBeforeMount(async () => {
      const url = `${Tag.ENDPOINT}/${route.params.id}`

      try {
        const resp = await http.get<Tag>(url)
        initTag.value = Tag.from(resp)
      } catch (errorResp) {
        error.value.title = errorResp.title
        error.value.body = errorResp.body
      }

      loading.value = false
    })

    const update = async (tag: Tag) => {
      try {
        const url = `${Tag.ENDPOINT}/${tag.id}`
        const resp = await http.put<Tag>(url, tag)
        initTag.value = Tag.from(resp)
      } catch (error) {
        return error
      }
    }

    return {
      initTag,
      error,
      loading,
      update
    }
  }
})
</script>
